import GenericCardHeader from "../GenericCardHeader/GenericCardHeader";
import { setCurrentHotspot } from "../../redux";
import { useDispatch, useSelector } from "react-redux";
import { getHotspotName } from "../../redux/selectors";

import { HotspotBackButton } from "../HotspotBackButton/HotspotBackButton";
import { RightComponent } from "../HotspotMoreMenu/HotspotMoreMenu";

export default function HotspotCardHeader() {
  const name = useSelector(getHotspotName);
  const dispatch = useDispatch();
  const handleClose = () => {
    dispatch(setCurrentHotspot(null));
  };
  return (
    <GenericCardHeader
      leftComponent={HotspotBackButton}
      title={name}
      rightComponent={RightComponent}
      onClose={handleClose}
    />
  );
}
